import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'wlm-alert-window',
    templateUrl: './alert-window.component.html',
    styleUrls: ['./alert-window.component.scss'],
    standalone: false
})
export class AlertWindowComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) {}
}
